<template>
    <div class="animated fadeIn">
        <div>
            <b-row v-if="loading">
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading">
            <b-row>
                <b-col>
                    <h3>Partner Report</h3>
                </b-col>
            </b-row>
            <b-card>
                <b-row>
                    <b-col cols="12">
                        <h3 class="head-text mb-3">
                            Partner Dashboard
                        </h3>

                        <b-row>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Total Partner"
                                    :value="totalPartner"
                                    bottomColor="#ffaf37"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Active Partners"
                                    :value="activePartners"
                                    bottomColor="#42b039"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Inactive Partners"
                                    :value="inactivePartners"
                                    bottomColor="var(--secondary)"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Low Balance Partner"
                                    :value="lowBalancePartner"
                                    bottomColor="#ff3a3a"
                                />
                            </b-col>
                            <b-col sm="6" md="4" lg="3" class="mb-3">
                                <dashboardInfoCard
                                    labelText="Partner Breached Item Count"
                                    :value="breachedItemCount"
                                    bottomColor="#ff3a3a"
                                />
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>

            <b-card>
                <b-row class="align-items-center">
                    <b-col cols="9" sm="6" md="4">
                        <h4 class="ml-2 mb-2 mb-sm-0">Top 10 Performers</h4>
                    </b-col>

                    <b-col
                        cols="3"
                        sm="6"
                        md="2"
                        class="text-sm-right mb-2 mb-md-0"
                    >
                        <a href="#">
                            <img
                                src="@/assets/images/DataExport.png"
                                class="upload-btn export-icon"
                                alt="data export"
                            />
                        </a>
                    </b-col>

                    <b-col cols="12" sm="6" md="3" class="mt-2 mt-md-2">
                        <eb-select
                            class="select-background-white"
                            id="text"
                            type="text"
                            label="text"
                            :options="orderOption"
                            v-model="selectOrderOption"
                            placeholder="By Order Count"
                            :selected="selectOrderOption.text"
                            @input="changeOrderOption"
                        ></eb-select>
                    </b-col>

                    <b-col cols="12" sm="6" md="3" class="mt-2 mt-md-2">
                        <eb-select
                            ref="dateRef"
                            class="select-background-white"
                            id="text"
                            type="text"
                            label="text"
                            :options="dateOption"
                            v-model="selectedDate"
                            :selected="selectedDate.text"
                            @input="changeDate"
                        ></eb-select>

                        <c-date
                            ref="compRefs"
                            modalRef="modalRef"
                            modalId="dateModal"
                            @customDateRange="findDateResult"
                        ></c-date>
                    </b-col>
                </b-row>

                <b-table
                    :items="items"
                    :hover="true"
                    striped
                    bordered
                    small
                    fixed
                    responsive="sm"
                    class="mt-3"
                    thead-class="header"
                    show-empty
                    :no-border-collapse="true"
                ></b-table>
            </b-card>

            <!-- <b-card
      ><b-row
        ><b-col md="9"> <h4>Partner By Mode</h4> </b-col
        ><b-col>
          <eb-select
            class="select-background-white"
            id="text"
            type="text"
            label="text"
            :options="dateOption1"
            v-model="selectedDate1"
            :selected="selectedDate1.text"
            @input="changeDate1"
          >
          </eb-select>
          <b-modal
            title="Select Date"
            header-class="header-nipige-class"
            id="dateRange"
            size="sm"
            ref="date-range"
            centered
            hide-footer
          >
            <b-input class="mb-2" type="date" v-model="startDate1"></b-input>
            <b-input type="date" v-model="endDate1"></b-input>
            <div class="text-center mt-2">
              <b-button
                @click="findButtonClick1()"
                class="my -0 main-navigation-button w-47 mr-2"
                variant="success"
                >Find
              </b-button>
            </div>
          </b-modal>
        </b-col></b-row
      >
      <BarChart :chart-data="chartData" :chart-options="barChartOptions" />
    </b-card> -->

            <b-card>
                <b-row class="align-items-center">
                    <b-col cols="9" sm="6" md="4">
                        <h4 class="ml-2 mb-2 mb-sm-0">Top 10 Performer</h4>
                    </b-col>

                    <b-col
                        cols="3"
                        sm="6"
                        md="2"
                        class="text-sm-right mb-2 mb-md-0"
                    >
                        <a href="#">
                            <img
                                src="@/assets/images/DataExport.png"
                                class="upload-btn export-icon"
                                alt="data export"
                            />
                        </a>
                    </b-col>

                    <b-col cols="12" sm="6" md="3" class="mt-2 mt-md-2">
                        <eb-select
                            class="select-background-white"
                            id="text"
                            type="text"
                            label="text"
                            :options="baseOptions"
                            v-model="selectedBase"
                            placeholder="City Wise"
                            @input="changeBaseFilter"
                        ></eb-select>
                    </b-col>

                    <b-col cols="12" sm="6" md="3" class="mt-2 mt-md-2">
                        <eb-select
                            ref="dateRef1"
                            class="select-background-white"
                            id="text"
                            type="text"
                            label="text"
                            :options="dateOption1"
                            v-model="selectedDate1"
                            :selected="selectedDate1.text"
                            @input="changeDate1"
                        ></eb-select>

                        <c-date
                            ref="compRefs1"
                            modalRef="modalRef1"
                            modalId="dateModal1"
                            @customDateRange="findDateResult1"
                        ></c-date>
                    </b-col>
                </b-row>

                <BarChart
                    :chart-data="marketWiseBarChart"
                    :chart-options="barChartOptions"
                    class="mt-3"
                />
            </b-card>

            <!-- <b-card>
      <b-row
        ><b-col md="4">
          <h4 class="ml-2">Low Balance Partner Report</h4>
        </b-col>
        <b-col md="2">
          <a href="#" class="text-right">
            <img
              src="@/assets/images/DataExport.png"
              class="upload-btn"
              alt="data export"
            />
          </a>
        </b-col>
        <b-col md="3">
          <eb-select
            class="select-background-white"
            id="text"
            type="text"
            label="text"
            :options="performer"
            v-model="selectPerformer"
            placeholder="Low Balance Partner"
            @input="changePerformer"
          >
          </eb-select>
        </b-col>
        <b-col>
          <eb-select
            class="select-background-white"
            id="text"
            type="text"
            label="text"
            :options="dateOption"
            v-model="selectedDate1"
            :selected="selectedDate1.text"
            @input="changeDate1"
          >
          </eb-select>
          <b-modal
            title="Select Date"
            header-class="header-nipige-class"
            id="dateRange"
            size="sm"
            ref="date-range"
            centered
            hide-footer
          >
            <b-input class="mb-2" type="date" v-model="startDate"></b-input>
            <b-input type="date" v-model="endDate"></b-input>
            <div class="text-center mt-2">
              <b-button
                @click="findButtonClick()"
                class="my -0 main-navigation-button w-47 mr-2"
                variant="success"
                >Find
              </b-button>
            </div>
          </b-modal>
        </b-col></b-row
      >
      <b-table
        :dark="false"
        :items="items1"
        :hover="true"
        striped
        bordered
        small
        fixed
        responsive="sm"
        id="my-table"
        :current-page="currentpage1"
        :per-page="perPage1"
        thead-class="header"
        class="mt-3"
        show-empty
        :fields="Columns1"
        :no-border-collapse="true"
        @filtered="onfilter1"
      ></b-table>
      <b-pagination
        class="pagination-right"
        v-model="currentPage1"
        :total-rows="filterCount1"
        :per-page="perPage1"
        prev-text="Prev"
        next-text="Next"
        aria-controls="myHistory"
        hide-goto-end-buttons
      ></b-pagination>
    </b-card> -->
        </div>
    </div>
</template>
<script>
import marketWiseChart from "@/utils/marketWiseChart";
import ComponentHeader from "@/components/componentNewHeader";
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import BarChart from "@/components/chart/BarChart";
import paymentChart from "@/utils/paymentChart";
import cDate from "@/components/FormElements/CustomDate.vue";
import { AtomSpinner } from "epic-spinners";
import dashboardInfoCard from "@/components/Generics/dashboardInfoCard.vue";

export default {
    name: "Reports",
    components: {
        ComponentHeader,
        dashboardInfoCard,
        ebSelect,
        evSelect,
        BarChart,
        cDate,
        AtomSpinner,
    },
    data() {
        return {
            prevSelectedDate: null,
            prevSelectedDate1: null,
            loading: false,
            activePartners: 0,
            totalPartner: 0,
            inactivePartners: 0,
            lowBalancePartner: 0,
            breachedItemCount: 0,
            filterCount: 1,
            filterCount1: 1,
            currentpage: 1,
            currentpage1: 1,
            Columns: [
                {
                    key: "partnerName",
                },
                {
                    key: "orderCount",
                },
                {
                    key: "orderValue",
                },
                {
                    key: "rank",
                },
            ],
            Columns1: [
                {
                    key: "partnerName",
                },
                {
                    key: "category",
                },
                {
                    key: "itemCount",
                },
                {
                    key: "commission",
                    label: "Commission %",
                },
            ],
            // items: [],
            items1: [],
            currentPage: 1,
            perPage: 9,
            currentPage1: 1,
            perPage1: 9,
            performer: [],
            selectPerformer: "",
            selectOrderOption: {
                text: "By Order Value",
                value: "By Order Value",
            },
            orderOption: [
                {
                    text: "By Order Count",
                    value: "By Order Count",
                },
                {
                    text: "By Order Value",
                    value: "By Order Value",
                },
            ],
            selectedDate: {
                text: "Today",
                value: 0,
            },
            dateOption: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 day's",
                    value: 6,
                },
                {
                    text: "30 day's",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate: "",
            endDate: "",
            startDate1: "",
            endDate1: "",
            performerFilter: "top10performer-byorder",
            marketCityFilter: "total-marketwish-partner-graph",
            selectedBase: {
                text: "Market Wise",
                value: "Market Wise",
            },
            baseOptions: [
                {
                    text: "Market Wise",
                    value: "Market Wise",
                },
                {
                    text: "City Wise",
                    value: "City Wise",
                },
            ],
            selectedDate1: {
                text: "Today",
                value: 0,
            },
            dateOption1: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 day's",
                    value: 6,
                },
                {
                    text: "30 day's",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate1: "",
            endDate1: "",
            barChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                    },
                    y: {
                        stacked: true,
                    },
                },
            },
        };
    },
    computed: {
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        chartData() {
            const data = this.$store.getters["partner/getChartData"];
            const prefix = this.getApiKeyPrefix();
            
            let PartnerAmount = "";
            let PartnerMode = "";
            
            if (this.$currentUserData.category === "TA") {
                PartnerAmount = "count";
                PartnerMode = "Partner";
            } else {
                PartnerAmount = "ordercount";
                PartnerMode = "Partnertype";
            }
            
            const Partnerkey = prefix
                ? `${prefix}orderbyPartnertype-graph`
                : "orderbyPartnertype-graph";
            const PartnerList = data[Partnerkey];
            
            return paymentChart(PartnerList, PartnerAmount, "date", PartnerMode);
        },
        chartData1() {
            const data = this.$store.getters["partner/GetBulkAnalyticsRept"];
            const prefix = this.getApiKeyPrefix();
            
            const dailyRegistrationKey = prefix
                ? `${prefix}daily-registration-graph`
                : "daily-registration-graph";
            const dailyRegistration = data[dailyRegistrationKey];
            
            return marketWiseChart(dailyRegistration, "count", "day");
        },
        marketWiseBarChart() {
            let data =
                this.$store.getters["partner/GetMarketWisePerformerData"];
            const labels = [];
            const datasets = [
                {
                    label: "Partner Count",
                    fill: true,
                    borderColor: "#0b91ba",
                    backgroundColor: "#0b91ba",
                    pointBorderColor: "#0b91ba",
                    borderWidth: 3,
                    yAxisID: "y",
                    data: [],
                },
            ];
            if (data && data["admin-total-citywish-partner-graph"]) {
                if (data["admin-total-citywish-partner-graph"].length > 0) {
                    data["admin-total-citywish-partner-graph"].map((x) => {
                        labels.push(x.city);
                        datasets[0].data.push(
                            +parseFloat(x.total_number).toFixed(2),
                        );
                    });
                }
            }
            if (data && data["admin-total-marketwish-partner-graph"]) {
    if (data["admin-total-marketwish-partner-graph"].length > 0) {
        data["admin-total-marketwish-partner-graph"]
            .filter(x => x.market?.toLowerCase() !== "adflash")
            .map((x) => {
                labels.push(x.market);
                datasets[0].data.push(
                    +parseFloat(x.provider).toFixed(2)
                );
            });
    }
}

            return {
                labels,
                datasets,
            };
        },
        items() {
            const data = this.$store.getters["partner/GetTop10PerformerData"];
            return data[this.performerFilter] || [];
        },
    },

    methods: {
        // Helper method to get API key prefix based on user role/category
        getApiKeyPrefix() {
            if (this.$currentUserData.role === "Admin") {
                return "admin-";
            } else if (this.$currentUserData.category === "SELLER") {
                return "seller-";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                return "subdealer-";
            }
            return ""; // TA category
        },
        // Helper method to get API variables based on user role/category
        getApiVariables(additionalVars = {}) {
            const baseVars = { ...additionalVars };
            if (this.$currentUserData.role === "Admin") {
                return baseVars;
            } else if (this.$currentUserData.category === "TA") {
                return { ...baseVars, tenant: this.userId };
            } else if (
                this.$currentUserData.category === "SELLER" ||
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                return {
                    ...baseVars,
                    userId: this.userId,
                    tenant: this.$currentUserData.tenant,
                };
            }
            return baseVars;
        },
        // Generic method to get date data
        getDateDataGeneric(dateData, startDateProp, endDateProp) {
            if (dateData === "custom") {
                return {
                    fromDate: this[startDateProp],
                    toDate: this[endDateProp],
                };
            }
            if (dateData === 0 || dateData === 1) {
                const daysToAdd = dateData === 0 ? 0 : 1;
                return {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().add(daysToAdd, "days").format("YYYY-MM-DD"),
                };
            }
            const data = {
                fromDate: moment()
                    .subtract(29, "days")
                    .format("YYYY-MM-DD"),
                toDate: moment().format("YYYY-MM-DD"),
            };
            if (typeof dateData === "number") {
                data.fromDate = moment()
                    .subtract(dateData, "days")
                    .format("YYYY-MM-DD");
                return data;
            } else if (typeof dateData === "object") {
                return dateData;
            }
            return data;
        },
        onfilter(list) {
            this.filtercount = list.length;
            this.currentpage = 1;
        },
        onfilter1(list) {
            this.filtercount1 = list.length;
            this.currentpage1 = 1;
        },
        async getAnalyticsData() {
            const prefix = this.getApiKeyPrefix();
            const dateData = this.getDateData(this.selectedDate.value);
            const variables = this.getApiVariables(dateData);

            const chartKey = prefix
                ? `${prefix}daily-registration-graph`
                : "daily-registration-graph";

            const payload = {
                items: [
                    {
                        key: chartKey,
                        variables: variables,
                    },
                ],
            };

            await this.$store.dispatch(
                "partner/fetchBulkAnalyticReport",
                payload,
            );
        },
        changePerformer() {
            //
        },
        changeOrderOption() {
            if (this.selectOrderOption.text === "By Order Count") {
                if (this.$currentUserData.role === "Admin") {
                    this.performerFilter = "admin-top10performer-byorder";
                } else {
                    this.performerFilter = "top10performer-byorder";
                }
            } else {
                //     this.performerFilter = "top10performer-byvalue";
                this.performerFilter = "admin-top10performer-byvalue";
            }
            this.fetchPerformerReport();
        },
        async fetchPerformerReport() {
            const dateData = this.getDateData(this.selectedDate.value);
            const variables = this.getApiVariables({
                ...dateData,
                limit: 10,
            });

            const payload = {
                items: [
                    {
                        key: this.performerFilter,
                        variables: variables,
                    },
                ],
            };

            await this.$store.dispatch("partner/fetchTop10Performer", payload);
        },
        changeBaseFilter() {
            if (this.selectedBase.text === "Market Wise") {
                this.marketCityFilter = "admin-total-marketwish-partner-graph";
            } else {
                this.marketCityFilter = "admin-total-citywish-partner-graph";
            }
            this.fetchMarketCityPerformers();
        },
        async fetchMarketCityPerformers() {
            const dateData = this.getDateData1(this.selectedDate1.value);
            const variables = this.getApiVariables(dateData);

            const payload = {
                items: [
                    {
                        key: this.marketCityFilter,
                        variables: variables,
                    },
                ],
            };

            await this.$store.dispatch(
                "partner/fetchMarketWisePerformer",
                payload,
            );
        },
        findDateResult1(e) {
            ((this.startDate1 = e.fromDate),
                (this.endDate1 = e.toDate),
                this.fetchMarketCityPerformers());
            // Market wise performer
        },
        changeDate1(e) {
            if (e.value === "custom") {
                this.prevSelectedDate1 = { ...this.selectedDate1 };
                this.selectedDate1 = this.prevSelectedDate1;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].close
                    ) {
                        this.$refs["dateRef1"].close();
                    } else if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].$el
                    ) {
                        const el =
                            this.$refs["dateRef1"].$el.querySelector("input") ||
                            this.$refs["dateRef1"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs1"].openModal();
                });
            } else {
                this.fetchMarketCityPerformers();
            }
        },
        getDateData1(dateData) {
            return this.getDateDataGeneric(dateData, "startDate1", "endDate1");
        },
        // Helper method to assign dashboard data for Admin/TA
        assignPartnerDashboardData(data, prefix) {
            const activePartnersKey = prefix
                ? `${prefix}active-partners`
                : "active-partners";
            const inactivePartnersKey = prefix
                ? `${prefix}inactive-partners`
                : "inactive-partners";
            const lowBalanceKey = prefix
                ? `${prefix}low-balance-partner-report`
                : "low-balance-partner-report";
            const breachedKey = prefix
                ? `${prefix}total-item-volume-breached`
                : "total-item-volume-breached";

            this.activePartners =
                data[activePartnersKey]?.count || 0;
            this.inactivePartners =
                data[inactivePartnersKey]?.count || 0;
            this.totalPartner =
                Number(this.activePartners || 0) +
                Number(this.inactivePartners || 0);
            this.lowBalancePartner =
                data[lowBalanceKey]?.[0]?.count || 0;
            this.breachedItemCount =
                data[breachedKey]?.[0]?.count || 0;
        },
        // Helper method to assign dashboard data for SELLER/DISTRIBUTOR
        assignSellerDashboardData(data, prefix) {
            const totalOrdersKey = `${prefix}total-orders`;
            const totalCollectedKey = `${prefix}total-collected`;
            const pendingKey = `${prefix}pending-collection`;
            const refundedKey = `${prefix}total-refunded`;
            const cancelledKey = `${prefix}total-Partner-cancelled`;

            this.activePartners =
                data[totalCollectedKey]?.activePartners ||
                data[totalCollectedKey]?.total_collected ||
                0;
            this.totalPartner = (
                +data[totalOrdersKey]?.total_order_amount || 0
            ).toFixed(2);
            this.totalFailed = data[cancelledKey]?.total_collected || 0;
            this.totalRefunded = data[refundedKey]?.total_collected || 0;
            this.totalPendingAmount = data[pendingKey]?.total_collected || 0;
        },
        async dashboardReport() {
            this.loading = true;

            if (
                this.$currentUserData.role === "Admin" ||
                this.$currentUserData.category === "TA"
            ) {
                // Admin and TA use similar structure
                const prefix = this.getApiKeyPrefix();
                const dateVars =
                    this.$currentUserData.role === "Admin"
                        ? this.fixedDate()
                        : { ...this.fixedDate() };
                const variables = this.getApiVariables(dateVars);

                const keys = [
                    "active-partners",
                    "inactive-partners",
                    "low-balance-partner-report",
                    "total-item-volume-breached",
                ];

                const payload = {
                    items: keys.map((key) => ({
                        key: prefix ? `${prefix}${key}` : key,
                        variables:
                            key === "total-item-volume-breached" &&
                            this.$currentUserData.category === "TA"
                                ? { tenant: this.userId }
                                : variables,
                    })),
                };

                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );

                this.assignPartnerDashboardData(data, prefix);
            } else if (
                this.$currentUserData.category === "SELLER" ||
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                // SELLER and DISTRIBUTOR/DEALER/SUB_DEALER use similar structure
                const prefix = this.getApiKeyPrefix();
                const dateData = this.getDateData1(this.selectedDate1.value);
                const variables = this.getApiVariables(dateData);

                const keys = [
                    "total-orders",
                    "total-collected",
                    "pending-collection",
                    "total-refunded",
                    "total-Partner-cancelled",
                ];

                const payload = {
                    items: keys.map((key) => ({
                        key: `${prefix}${key}`,
                        variables: variables,
                    })),
                };

                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload,
                );

                this.assignSellerDashboardData(data, prefix);

                // Fetch month data
                const monthVariables = this.getApiVariables({
                    fromDate: this.getProperDate1(
                        moment().startOf("month").toISOString(),
                    ),
                    toDate: this.getProperDate1(
                        moment().add(+1, "days").toDate().toISOString(),
                    ),
                });

                const payload1 = {
                    items: [
                        {
                            key: `${prefix}total-orders`,
                            variables: monthVariables,
                        },
                    ],
                };

                const data1 = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    payload1,
                );

                this.totalPartnerMonth = (
                    +data1[`${prefix}total-orders`]?.total_order_amount || 0
                ).toFixed(2);
            }
            this.loading = false;
        },
        getProperDate1(data) {
            if (data != null) {
                let date = new Date(data);
                return moment(String(date)).format("YYYY-MM-DD");
            } else return "Unavailable";
        },
        fixedDate() {
            let date = new Date();
            let today = moment(String(date)).format("YYYY-MM-DD");
            let dateObj = {
                fromDate: "1990-01-01",
                toDate: today,
            };
            return dateObj;
        },
        findDateResult(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            this.selectedDate.value = "custom";
            this.fetchPerformerReport();
        },
        changeDate(e) {
            if (e.value === "custom") {
                this.prevSelectedDate = { ...this.selectedDate };
                this.selectedDate = this.prevSelectedDate;
                this.$nextTick(() => {
                    if (this.$refs["dateRef"] && this.$refs["dateRef"].close) {
                        this.$refs["dateRef"].close();
                    } else if (
                        this.$refs["dateRef"] &&
                        this.$refs["dateRef"].$el
                    ) {
                        const el =
                            this.$refs["dateRef"].$el.querySelector("input") ||
                            this.$refs["dateRef"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs"].openModal();
                });
            } else {
                this.fetchPerformerReport();
            }
        },

        getDateData(dateData) {
            return this.getDateDataGeneric(dateData, "startDate", "endDate");
        },
        async fetchPartnerChart() {
            const prefix = this.getApiKeyPrefix();
            const dateData = this.getDateData(this.selectedDate.value);
            const variables = this.getApiVariables(dateData);

            const chartKey = prefix
                ? `${prefix}orderbyPartnertype-graph`
                : "orderbyPartnertype-graph";

            const payload = {
                items: [
                    {
                        key: chartKey,
                        variables: variables,
                    },
                ],
            };

            await this.$store.dispatch("partner/fetchChart", payload);
        },
    },
    mounted() {
        this.dashboardReport();
        this.fetchPerformerReport();
        this.fetchMarketCityPerformers();
    },
};
</script>
<style scoped>
.head-text {
    margin-bottom: 0px;
    font-size: 1.125rem;
    font-weight: 600;
    color: #000000;
}
.green-chart-icon i {
    background: #def6ee;
    text-align: center;
    color: #65d27d;
    border-radius: 5px;
    font-size: 16px !important;
    height: 36px;
    width: 36px;
    line-height: 36px;
}

.order-price-heading {
    line-break: anywhere;
    line-height: 24px;
}

.total-order-header .card-header {
    background: var(--primary);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.upload-btn {
    height: 39px;
}

.export-icon {
    height: 36px;
    cursor: pointer;
}

.select-background-white {
    background-color: #fff;
}

.pagination-right {
    float: right;
}

@media (max-width: 767.98px) {
    .pagination-right {
        float: none;
        text-align: center;
        width: 100%;
    }
}
</style>
